import {
  getApiService,
  ResponseBase,
  DEFAULT_API_PARAMS,
} from "@/api/api.service";
import { AxiosInstance, AxiosResponse } from "axios";
import { ContactFormInputData } from "@/views/contact-form/ContactForm.vue";

export interface GetContactTokenResponse extends ResponseBase {
  data?: { inquiry_token: string };
}

export interface SendContactFormResponse extends ResponseBase {
  data?: object;
}

class ContactService {
  axiosInstance: AxiosInstance;
  constructor() {
    this.axiosInstance = getApiService();
  }
  getContactToken(): Promise<AxiosResponse<GetContactTokenResponse>> {
    return this.axiosInstance.post<GetContactTokenResponse>(
      "inquiryToken",
      DEFAULT_API_PARAMS
    );
  }
  sendContactForm(
    params: ContactFormInputData
  ): Promise<AxiosResponse<SendContactFormResponse>> {
    return this.axiosInstance.post<SendContactFormResponse>("inquirySend", {
      ...params,
      ...DEFAULT_API_PARAMS,
    });
  }
}

export default new ContactService();
